var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "enter_app"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('Spin', {
    attrs: {
      "fix": ""
    }
  }, [_vm._v($t("iocvda6", "跳转中。。。"))])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };